'use strict';
function NgAutofocus() {
	return {
		restrict: 'A',
		link: function(scope, iElem, iAttrs) {
			iElem.attr('tabindex', '-1');
			iElem.focus();
		}
	}
}
export default NgAutofocus


// WEBPACK FOOTER //
// ./src/app/scripts/directives/ngAutofocusDirective.js